module.exports = __webpack_public_path__ + "static/media/travelwell.9252130a.svg";